import { render } from "./CancelOrderDetails.vue?vue&type=template&id=745920bb&scoped=true"
import script from "./CancelOrderDetails.vue?vue&type=script&lang=js"
export * from "./CancelOrderDetails.vue?vue&type=script&lang=js"

import "./CancelOrderDetails.vue?vue&type=style&index=0&id=745920bb&lang=scss&scoped=true"

import exportComponent from "/opt/buildhome/repo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-745920bb"]])

export default __exports__
import QInput from 'quasar/src/components/input/QInput.js';
import QRadio from 'quasar/src/components/radio/QRadio.js';
import QInnerLoading from 'quasar/src/components/inner-loading/QInnerLoading.js';
import QImg from 'quasar/src/components/img/QImg.js';
import QBtn from 'quasar/src/components/btn/QBtn.js';
import qInstall from "../../../node_modules/vue-cli-plugin-quasar/lib/runtime.auto-import.js";
qInstall(script, 'components', {QInput,QRadio,QInnerLoading,QImg,QBtn});
